import { ImageProps } from 'next/image';

import { ResponsiveImage } from '../../ResponsiveImage/ResponsiveImage';

interface VimeoPlayerPreviewProps {
  resolvedImage?: ImageProps;
}

export const VimeoPlayerPreview = ({ resolvedImage }: VimeoPlayerPreviewProps) => (
  <div className="react-player">
    {resolvedImage?.src ? (
      <ResponsiveImage
        {...resolvedImage}
        className="absolute left-0 top-0 h-full w-full animate-pulse object-cover"
      />
    ) : (
      <div className="bg-primary/10 absolute left-0 top-0 h-full w-full rounded-md" />
    )}
  </div>
);
